// extracted by mini-css-extract-plugin
export var container = "_2q-0";
export var icon = "_2q-1";